import { useEffect, useState } from "react";
import { fetchCallAllDataByIDAPI } from "../utils/api";

const normalizeMap = (rawMap) => {
    const out = {};
    Object.entries(rawMap || {}).forEach(([key, value]) => {
        const code = String(key || "").trim().toUpperCase();
        const name = String(value || "").trim();
        if (code && name) out[code] = name;
    });
    return out;
};

const usePpcTeamMap = () => {
    const [teamByCode, setTeamByCode] = useState({});

    useEffect(() => {
        let active = true;
        fetchCallAllDataByIDAPI("ppc-team-prefix-map").then((res) => {
            if (!active) return;
            if (res?.data?.status === 1) {
                setTeamByCode(normalizeMap(res?.data?.data?.map || {}));
            }
        }).catch(() => {
            if (active) setTeamByCode({});
        });

        return () => {
            active = false;
        };
    }, []);

    return teamByCode;
};

export default usePpcTeamMap;
